import { Component, OnInit, OnDestroy } from '@angular/core';

import { PhoneService } from '../services';
import { PhoneList, Brand } from '../models';

@Component({
  selector: 'app-all-brands',
  templateUrl: './all-brands.component.html',
  styleUrls: ['./all-brands.component.scss']
})
export class AllBrandsComponent implements OnInit, OnDestroy {
  private sub;
  brands: Brand[];

  constructor(private phoneService: PhoneService) { }

  ngOnInit() {
    this.sub = this.phoneService.obs.phoneList
      .subscribe((phoneList: PhoneList) => {
        this.brands = <Array<Brand>>Array.from(phoneList.brands.values());
        console.log(this.brands);
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/all-brands/all-brands.component.ts